// Complete the look: our own cards and one Add to bag, with data from Unbxd's recommendations API.
(function () {
  var band = document.getElementById('mz-ctl');
  if (!band) return;
  var grid = document.getElementById('mz-ctl-grid');
  var go = document.getElementById('mz-ctl-go');
  var msg = document.getElementById('mz-ctl-msg');
  var key = band.getAttribute('data-key');
  var site = band.getAttribute('data-site');
  var WIDGET = 'widget2';
  var PAGE = 'PRODUCT';
  var items = [];
  var reqId = 'req-' + Date.now();

  var debug = /[?&]mzdebug=1/.test(location.search) || localStorage.getItem('mzdebug') === '1';
  function log() {
    if (debug) console.log.apply(console, ['[mz-ctl]'].concat([].slice.call(arguments)));
  }

  function cookie(name) {
    var m = document.cookie.match('(?:^|; )' + name.replace(/\./g, '\\.') + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : '';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; });
  }

  function money(cents) {
    var d = cents / 100;
    return '$' + d.toLocaleString('en-AU', { minimumFractionDigits: d % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }

  function pid() {
    var m = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (m && m.id) return String(m.id);
    var el = document.querySelector('.nn-product[data-product-id]');
    return el ? el.getAttribute('data-product-id') : '';
  }

  function track(type, data) {
    log('track', type, data);
    if (window.Unbxd && typeof Unbxd.track === 'function') {
      try { Unbxd.track(type, data); } catch (e) { log('track failed', e); }
    }
  }

  function handleOf(rec) {
    var m = (rec.productUrl || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function build(rec, product) {
    var variants = product.variants || [];
    var avail = variants.filter(function (v) { return v.available; });
    var multi = variants.length > 1;
    var it = {
      rec: rec,
      product: product,
      multi: multi,
      ok: avail.length > 0,
      variantId: !multi && avail[0] ? avail[0].id : multi && avail.length === 1 ? avail[0].id : null,
      selected: avail.length > 0,
    };
    it.price = (avail[0] || variants[0] || {}).price || 0;
    return it;
  }

  function cardHtml(it, i) {
    var r = it.rec;
    var img = (r.imageUrl && (r.imageUrl[0] || r.imageUrl)) || '';
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=480';
    var url = r.productUrl || '#';
    var tags = r.tags || r.clean_tags || [];
    var mystery = tags.indexOf('mystery-discount') > -1 && ['TAG Heuer', 'Rado', 'Tissot', 'Longines'].indexOf(r.vendor) < 0;
    var sizes = '';
    if (it.multi && it.ok) {
      sizes = '<select class="mz-ctl-size" data-i="' + i + '" aria-label="Choose a size for ' + esc(r.title) + '"><option value="">Choose size</option>';
      it.product.variants.forEach(function (v) {
        sizes += '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + (String(it.variantId) === String(v.id) ? ' selected' : '') + '>' +
          esc(v.public_title || v.title) + (v.available ? '' : ' (sold out)') + '</option>';
      });
      sizes += '</select>';
    }
    return '<div class="mz-ctl-card' + (it.ok ? '' : ' is-oos') + '" data-i="' + i + '">' +
      '<div class="mz-ctl-img"><a href="' + esc(url) + '" target="_blank" rel="noopener" data-i="' + i + '"><img src="' + esc(img) + '" alt="' + esc(r.title) + '" loading="lazy"></a>' +
      '<label class="mz-ctl-check"><input type="checkbox" data-i="' + i + '"' + (it.selected && it.ok ? ' checked' : '') + (it.ok ? '' : ' disabled') + ' aria-label="Select ' + esc(r.title) + '"><span></span></label></div>' +
      '<a class="mz-ctl-title" href="' + esc(url) + '" target="_blank" rel="noopener" data-i="' + i + '">' + esc(r.title) + '</a>' +
      (mystery ? '<p class="mz-ctl-mystery">See your price in bag</p>' : '') +
      '<p class="mz-ctl-price">' + money(it.price) + '</p>' +
      sizes +
      (it.ok ? '' : '<span class="mz-ctl-oos">Out of stock</span>') +
      '</div>';
  }

  function count() {
    return items.filter(function (it) { return it.ok && it.selected; }).length;
  }

  function sync() {
    var n = count();
    go.classList.toggle('is-idle', n === 0);
    go.textContent = n ? 'Add ' + n + ' selected to bag' : 'Select pieces to add';
  }

  function kinds() {
    var words = [['pendant', 'pendant'], ['necklace', 'necklace'], ['earring', 'earrings'], ['stud', 'earrings'], ['huggie', 'earrings'], ['drop', 'earrings'], ['hoop', 'earrings'], ['bracelet', 'bracelet'], ['bangle', 'bangle'], ['ring', 'ring']];
    var seen = [];
    items.forEach(function (it) {
      var t = ((it.rec.productType || '') + ' ' + (it.rec.title || '')).toLowerCase();
      for (var i = 0; i < words.length; i++) {
        if (t.indexOf(words[i][0]) > -1) {
          if (seen.indexOf(words[i][1]) < 0) seen.push(words[i][1]);
          break;
        }
      }
    });
    return seen;
  }

  function addTeaser() {
    if (document.querySelector('.mz-ctl-teaser')) return;
    var price = document.querySelector('.nn-product-details .nn-product-details-price');
    if (!price) return;
    var k = kinds();
    var text = 'Matching pieces to complete the look';
    if (k.length) {
      var last = k.pop();
      text = 'Matching ' + (k.length ? k.join(', ') + ' and ' + last : last);
    }
    var a = document.createElement('a');
    a.className = 'mz-ctl-teaser';
    a.href = '#mz-ctl';
    a.innerHTML = '<span class="mz-ctl-teaser-text"></span><span class="mz-ctl-teaser-link">View the set</span>';
    a.querySelector('.mz-ctl-teaser-text').textContent = text;
    a.addEventListener('click', function (e) {
      e.preventDefault();
      band.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    price.insertAdjacentElement('afterend', a);
  }

  function render(title) {
    if (title) band.querySelector('.mz-ctl-heading').textContent = title;
    grid.innerHTML = items.map(cardHtml).join('');
    sync();
    band.hidden = false;
    addTeaser();
    track('experience_impression', {
      experience_pagetype: PAGE,
      experience_widget: WIDGET,
      identifier: reqId,
      pids_list: items.map(function (it) { return String(it.rec.uniqueId); }),
    });
  }

  grid.addEventListener('change', function (e) {
    var i = e.target.getAttribute('data-i');
    if (i == null) return;
    var it = items[i];
    if (e.target.type === 'checkbox') {
      it.selected = e.target.checked;
    } else if (e.target.classList.contains('mz-ctl-size')) {
      it.variantId = e.target.value || null;
      e.target.classList.remove('is-missing');
    }
    msg.textContent = '';
    sync();
  });

  grid.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-i]');
    if (!a) return;
    var it = items[a.getAttribute('data-i')];
    track('click', {
      pid: String(it.rec.uniqueId),
      prank: Number(a.getAttribute('data-i')),
      experience_pagetype: PAGE,
      experience_widget: WIDGET,
      requestId: reqId,
    });
  });

  // fill the theme's own added to bag templates so the popup stays one design
  function tmpl(id, data) {
    var t = document.getElementById(id);
    var html = t ? t.innerHTML.trim() : '';
    Object.keys(data).forEach(function (k) { html = html.split('[[' + k + ']]').join(data[k]); });
    return html;
  }

  function added(response, chosen) {
    var list = response.items || [response];
    var rows = list.map(function (item) {
      var line = item.final_line_price != null ? item.final_line_price : item.price;
      return tmpl('tmpl-cart-item-added-notification-line-item', {
        title: esc(item.product_title || item.title),
        quantity: item.quantity,
        price_html: money(line),
        image_tag: item.image ? '<img src="' + esc(item.image) + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=240"/>' : '',
      });
    }).join('');
    var old = document.querySelector('.nn-cart-item-added-notification');
    if (old) old.remove();
    var holder = document.createElement('div');
    holder.innerHTML = tmpl('tmpl-cart-item-added-notification', { line_item_list_html: rows });
    if (holder.firstElementChild) document.body.appendChild(holder.firstElementChild);
    chosen.forEach(function (it) {
      track('addToCart', { pid: String(it.rec.uniqueId), qty: 1, variantId: String(it.variantId), requestId: reqId });
    });
    if (window.nnHelpers && nnHelpers.refreshCart) nnHelpers.refreshCart();
  }

  go.addEventListener('click', function () {
    var chosen = items.filter(function (it) { return it.ok && it.selected; });
    if (!chosen.length) return;
    var missing = chosen.filter(function (it) { return !it.variantId; });
    if (missing.length) {
      missing.forEach(function (it) {
        var s = grid.querySelector('.mz-ctl-size[data-i="' + items.indexOf(it) + '"]');
        if (s) s.classList.add('is-missing');
      });
      msg.textContent = 'Choose a size for the highlighted piece' + (missing.length > 1 ? 's' : '') + '.';
      return;
    }
    msg.textContent = '';
    go.classList.add('is-loading');
    var payload = chosen.map(function (it) { return { id: Number(it.variantId), quantity: 1 }; });
    log('adding', payload);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: payload }),
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to bag');
        added(res.j, chosen);
      })
      .catch(function (e) { msg.textContent = e.message; })
      .then(function () { go.classList.remove('is-loading'); });
  });

  function start() {
    var id = pid();
    if (!id) return;
    if (!window.__mzRecs) {
      var uid = cookie('unbxd.userId') || '123456';
      window.__mzRecs = fetch('https://anz-recommendations.unbxd.io/v3.0/' + key + '/' + site + '/recommendation?template=false&pageType=' + PAGE +
        '&uid=' + encodeURIComponent(uid) + '&id=' + encodeURIComponent(id))
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    window.__mzRecs
      .then(function (d) {
        var w = ((d.response && d.response.widgets) || []).filter(function (x) { return x.widgetId === WIDGET; })[0];
        var recs = ((w && w.recommendations) || []).filter(function (r) { return handleOf(r); }).slice(0, 4);
        log('widget', WIDGET, recs.length, 'products');
        if (!recs.length) return;
        return Promise.all(recs.map(function (r) {
          return fetch('/products/' + handleOf(r) + '.js').then(function (x) { return x.json(); }).then(function (p) { return build(r, p); }).catch(function () { return null; });
        })).then(function (built) {
          items = built.filter(Boolean);
          if (items.length) render(w.widgetTitle);
        });
      })
      .catch(function (e) { log('recommendations failed', e); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
